// extracted by mini-css-extract-plugin
export default {"slider":"Vi9x5p_AhStq1e1RYhQa","warning":"zOqQXC0w5pbqQbygTwid"};